module.exports = __webpack_public_path__ + "static/media/S_F01.b9ba51e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/S_F01.png
// module id = 132
// module chunks = 0